import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import slide1 from "../assets/slide1.png";
import slide2 from "../assets/slide2.png";
import slide3 from "../assets/slide3.png";
import slide4 from "../assets/slide4.png";
import slide5 from "../assets/slide5.png";
import slide6 from "../assets/slide6.png";

import "./Slider.css";

const Slider = () => {
  const sliderImages = [
    slide1,
    slide2,
    slide3,
    slide4,
    slide5,
    slide6,
  ];

  // Convert images to AliceCarousel items
  const items = sliderImages.map((img, index) => (
    <div className="item" key={index}>
      <img src={img} alt={`Slide ${index + 1}`} className="image" />
    </div>
  ));

  return (
    <section className="image-slider">
      <AliceCarousel
        items={items}
        autoPlay
        infinite
        autoPlayInterval={4000}
        disableButtonsControls
        disableDotsControls={false} // Optional: set to true if you don’t want dots
        mouseTracking
      />
    </section>
  );
};

export default Slider;
